import React, { useState } from 'react';

// material
import { alpha, styled, createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Card, Box, Grid, Typography,
  Divider,
  Stack,
  Skeleton, useMediaQuery, useTheme
} from '@mui/material';



const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "100px",
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    marginBottom: '10px'
  },
});


// ----------------------------------------------------------------------

let TOTAL = 0;

if (process.env.REACT_APP_ENVIRONMENT === "development")
  TOTAL = 800






export default function SoundBoxDevicesStats({ admindashboardData }) {

  const [expanded, setExpanded] = useState(false);

  const classes = useStyles();

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,    
        sm: 768,  
        md: 1024, 
        lg: 1280, 
        xl: 390,  
      },
    },
  });
  const isMediumUp = useMediaQuery(theme.breakpoints.up('sm'));


  return (
    <Box>

      <Card className={classes.customDashCard} >

        <Grid container spacing={1} direction={{md:'auto', sm: 'auto', xs: 'auto'}}>
          <Grid item xs={12} sm={12} md={3}>

            <Box sx={{ textAlign: "center" }}>

              {
                admindashboardData?.merchant_stats?.TotalMerchant !== undefined && admindashboardData?.merchant_stats?.TotalMerchant !== null ?
                  <>
                    <Typography sx={{ fontWeight: 900, color: "#171D40", fontSize:{ xs:"33px", md: "35px"}, lineHeight: { xs:"33px", md: "35px"}}}>
                      {admindashboardData?.merchant_stats?.TotalMerchant}
                    </Typography>
                    <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "16px", lineHeight: "25px" }}>
                      Total Merchants
                    </Typography>
                  </>

                  :
                  <>
                    <Skeleton variant="text" sx={{ fontSize: '2.3rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                  </>
              }



            </Box>


          </Grid>

          <Grid item xs={12} sm={12} md={5} mt={1} mb={1} >

            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={{ xs: 8, md: 3 }}
              ml={{xs: 2.5, sm:25, md:'auto'}}
            >

              <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={.5}
              >
                {admindashboardData?.merchant_stats?.Ordered !== undefined && admindashboardData?.merchant_stats?.Ordered !== null
                  ?
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                      <Typography sx={{ fontWeight: 700, color: "#0DA626", pr: 1, fontSize: "14px", lineHeight: "18px", minWidth: '5vw' }}>Ordered : </Typography>
                      <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px", textAlign: 'center' }}>{admindashboardData?.merchant_stats?.Ordered}</Typography>
                    </Box>
                  :
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                      <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80, pr: 1 }} />
                      <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80 }} />
                    </Box>
                }

                {admindashboardData?.merchant_stats?.Activate !== undefined && admindashboardData?.merchant_stats?.Activate !== null
                  ?
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                      <Typography sx={{ fontWeight: 700, color: "#0DA626", pr: 1, fontSize: "14px", lineHeight: "18px", minWidth: '5vw' }}>Active : </Typography>
                      <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{admindashboardData?.merchant_stats?.Activate}</Typography>
                    </Box>
                  :
                  <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80, pr: 1 }} />
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80 }} />
                </Box>

                }




              </Stack>



              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={.5}
              >


                {admindashboardData?.merchant_stats?.Delivered !== undefined && admindashboardData?.merchant_stats?.Delivered !== null
                  ?
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                      <Typography sx={{ fontWeight: 700, color: "#0DA626", pr: 1, fontSize: "14px", lineHeight: "18px", minWidth: '7vw' }}>Delivered : </Typography>
                      <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px", textAlign: 'center' }}>{admindashboardData?.merchant_stats?.Delivered}</Typography>
                    </Box>
                  :
                  <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80, pr: 1 }} />
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80 }} />
                </Box>


                }


                {admindashboardData?.merchant_stats?.OnTheWay !== undefined && admindashboardData?.merchant_stats?.OnTheWay !== null
                  ?
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                      <Typography sx={{ fontWeight: 700, color: "#0DA626", pr: 1, fontSize: "14px", lineHeight: "18px", minWidth: '7vw' }}>On The Way : </Typography>
                      <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{admindashboardData?.merchant_stats?.OnTheWay}</Typography>
                    </Box>
                  :
                  <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80, pr: 1 }} />
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80 }} />
                </Box>


                }

              </Stack>
            </Stack>
          </Grid>


            {isMediumUp && (
              <Grid item md={0.5} mt={1} mb={1}>
                <Divider
                  sx={{
                    borderColor: 'rgba(0, 0, 0, 0.2)',
                  }}
                  orientation="vertical"
                />
              </Grid>
            )}


          <Grid item xs={12} sm={12} md={3.5} mt={1} mb={1} ml={{sm:35, xs:'auto', md:'auto'}} >

            <Stack
              direction="column"
              justifyContent="center"
              alignItems={{xs: "center", sm:'flex-start', md:"flex-start"}}
              spacing={{xs:0.5, md:1}}
              ml={2}
            >

              {admindashboardData?.others_stats?.Deactive !== undefined && admindashboardData?.others_stats?.Deactive !== null
                ?
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left', minWidth: '30%' }}>
                    <Typography sx={{ fontWeight: 700, color: "#C30A0A", pr: 1, fontSize: "14px", lineHeight: "18px", }}>Deactive : </Typography>
                    <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{admindashboardData?.others_stats?.Deactive}</Typography>
                  </Box>
                :
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80, pr: 1 }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 80 }} />
              </Box>


              }

              {admindashboardData?.others_stats?.["Delisted "] !== undefined && admindashboardData?.others_stats?.["Delisted "] !== null
                ?
                  <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                    <Typography sx={{ fontWeight: 700, color: "#C30A0A", pr: 1, fontSize: "14px", lineHeight: "18px" }}>Delisted : </Typography>
                    <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{admindashboardData?.others_stats?.["Delisted "]}</Typography>
                  </Box>
                
                :
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%', }}>
                <Skeleton variant="text" sx={{ fontSize: '1.3rem', width: 80, pr: 1 }} />
                <Skeleton variant="text" sx={{ fontSize: '1.3rem', width: 80 }} />
              </Box>


              }

            </Stack>
          </Grid>

        </Grid>


      </Card>



    </Box>
  );
}
